import { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { RoleList } from './RoleList';
import { RoleDrawer } from './RoleDrawer';
import { useRoles } from '@/hooks/roles';
import { useHasPermission } from '@/hooks/permissions';
import { Role } from '@/types/roles';

export function RoleManagement() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedRole, setSelectedRole] = useState<Role | null>(null);
  const { data: roles, isLoading } = useRoles();
  const canManageRoles = useHasPermission('can_manage_roles');

  const handleCreateRole = () => {
    setSelectedRole(null);
    setDrawerOpen(true);
  };

  const handleEditRole = (role: Role) => {
    setSelectedRole(role);
    setDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setSelectedRole(null);
  };

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-4">
        <div>
          <CardTitle>Role Management</CardTitle>
          <CardDescription>
            Define roles and manage permissions
          </CardDescription>
        </div>
        {canManageRoles && (
          <Button onClick={handleCreateRole} size="sm">
            <Plus className="h-4 w-4 mr-2" />
            Add Role
          </Button>
        )}
      </CardHeader>
      <CardContent>
        <RoleList 
          roles={roles || []} 
          isLoading={isLoading}
          onEditRole={handleEditRole}
          canManageRoles={canManageRoles}
        />
      </CardContent>

      <RoleDrawer
        open={drawerOpen}
        onClose={handleCloseDrawer}
        role={selectedRole}
        allRoles={roles || []}
      />
    </Card>
  );
}
